import { render } from "./RefAnimal.vue?vue&type=template&id=1452d469&scoped=true"
import script from "./RefAnimal.vue?vue&type=script&lang=js"
export * from "./RefAnimal.vue?vue&type=script&lang=js"

import "./RefAnimal.vue?vue&type=style&index=0&id=1452d469&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1452d469"]])

export default __exports__